import {MatchmakingCancelReason} from '../../../../../../../../shared/matchmaking/MatchmakingEnums'
import {SocketMatchmakingSend} from '../../../../../../../shared/scripts/socket/SocketMatchmakingSend'
import {UIMMatchmakingSearchingView} from './UIMMatchmakingSearchingView'
import {UIMMatchmakingSelection1v1View} from './UIMMatchmakingSelection1v1View'
import {UIMMatchmakingSelectionClassic4PView} from './UIMMatchmakingSelectionClassic4PView'
import {UIMMatchmakingSelectionCnKView} from './UIMMatchmakingSelectionCnKView'
import {UIMMatchmakingSelectionPlayVsBotsView} from './UIMMatchmakingSelectionPlayVsBotsView'
import {UIMMatchmakingSelectionView} from './UIMMatchmakingSelectionView'
import {UIMMatchmakingSearching1v1View} from './UIMMatchmakingSearching1v1View'
import {UIMMatchmakingSearchingClassic4PView} from './UIMMatchmakingSearchingClassic4PView'
import {UIMMatchmakingSearchingCnKView} from './UIMMatchmakingSearchingCnKView'
import {MatchmakingStatusUpdate} from '../../../../../../../../shared/matchmaking/MatchmakingInterfaces'
import {UIMMatchmakingActionsController} from '../UIMMatchmakingActionsController'
import {logError} from '../../../../../../../shared/scripts/ui_utils/Utils'
import {MatchmakingMatchTypes} from '@colonist/game-base-types'
import {getMatchTypeEligibility} from '../../../../../../../shared/scripts/matchmaking/MatchmakingUtilsClient'
import {ClientUserState} from '../../../../../../../shared/scripts/ClientUserState'

export enum GameTypeEnum {
    PlayVsBots = 0,
    Classic1v1 = 1,
    Classic4P = 2,
    CitiesAndKnights4P = 3,
}

export class UIMMatchmakingController {
    private matchmakingSelectionView: UIMMatchmakingSelectionView
    private matchmakingSearchingView: UIMMatchmakingSearchingView
    readonly matchmakingActionsController: UIMMatchmakingActionsController

    constructor() {
        this.matchmakingActionsController = new UIMMatchmakingActionsController()
    }

    showSelectionScreen(gameMode: GameTypeEnum) {
        switch(gameMode) {
            case GameTypeEnum.PlayVsBots:
                this.matchmakingSelectionView = new UIMMatchmakingSelectionPlayVsBotsView(this)
                return
            case GameTypeEnum.Classic4P:
                this.matchmakingSelectionView = new UIMMatchmakingSelectionClassic4PView(this)
                return
            case GameTypeEnum.Classic1v1:
                this.matchmakingSelectionView = new UIMMatchmakingSelection1v1View(this)
                return
            case GameTypeEnum.CitiesAndKnights4P:
                this.matchmakingSelectionView = new UIMMatchmakingSelectionCnKView(this)
                return
            default:
                logError('showSelectionScreen', [`Unknown game mode: ${gameMode}`])
                return
        }
    }

    removeSelectionScreen() {
        if(this.matchmakingSelectionView != undefined) this.matchmakingSelectionView.removeFromDOM()
    }

    async startSearching(gameType: GameTypeEnum, isRanked: boolean) {
        let gameMode

        if(!UIMMatchmakingController.canPlayGameType(gameType, isRanked)) return
        if(gameType != GameTypeEnum.PlayVsBots) await ClientUserState.requireUser()

        switch(gameType) {
            case GameTypeEnum.PlayVsBots:
                return
            case GameTypeEnum.Classic4P:
                this.matchmakingSearchingView = new UIMMatchmakingSearchingClassic4PView(this, isRanked)
                gameMode = isRanked ? MatchmakingMatchTypes.RankedClassic4P : MatchmakingMatchTypes.UnrankedClassic4P
                this.matchmakingActionsController.sendFindGameMessageToServer([gameMode])
                return
            case GameTypeEnum.Classic1v1:
                this.matchmakingSearchingView = new UIMMatchmakingSearching1v1View(this, isRanked)
                gameMode = isRanked ? MatchmakingMatchTypes.RankedClassic1v1 : MatchmakingMatchTypes.UnrankedClassic1v1
                this.matchmakingActionsController.sendFindGameMessageToServer([gameMode])
                return
            case GameTypeEnum.CitiesAndKnights4P:
                this.matchmakingSearchingView = new UIMMatchmakingSearchingCnKView(this, isRanked)
                gameMode = isRanked ? MatchmakingMatchTypes.RankedCitiesAndKnights4P : MatchmakingMatchTypes.UnrankedCitiesAndKnights4P
                this.matchmakingActionsController.sendFindGameMessageToServer([gameMode])
                return
        }
    }

    private static canPlayGameType(gameType: GameTypeEnum, isRanked: boolean): boolean {
        let matchmakingMatchType: MatchmakingMatchTypes
        if(isRanked) {
            switch(gameType) {
                case GameTypeEnum.PlayVsBots: return true
                case GameTypeEnum.Classic1v1: matchmakingMatchType = MatchmakingMatchTypes.RankedClassic1v1; break
                case GameTypeEnum.Classic4P: matchmakingMatchType = MatchmakingMatchTypes.RankedClassic4P; break
                case GameTypeEnum.CitiesAndKnights4P: matchmakingMatchType = MatchmakingMatchTypes.RankedCitiesAndKnights4P; break
            }
        } else {
            switch(gameType) {
                case GameTypeEnum.PlayVsBots: return true
                case GameTypeEnum.Classic1v1: matchmakingMatchType = MatchmakingMatchTypes.UnrankedClassic1v1; break
                case GameTypeEnum.Classic4P: matchmakingMatchType = MatchmakingMatchTypes.UnrankedClassic4P; break
                case GameTypeEnum.CitiesAndKnights4P: matchmakingMatchType = MatchmakingMatchTypes.UnrankedCitiesAndKnights4P; break
            }
        }

        return getMatchTypeEligibility([matchmakingMatchType])
    }

    stopSearching() {
        this.matchmakingSearchingView.removeFromDOM()
        SocketMatchmakingSend.sendCancelFindGame(MatchmakingCancelReason.ClickedCancel)
    }

    removeSearchingScreen() {
        if(this.matchmakingSearchingView != undefined) this.matchmakingSearchingView.removeFromDOM()
    }

    closeAll() {
        if(this.matchmakingSelectionView != undefined) this.removeSelectionScreen()
        if(this.matchmakingSearchingView != undefined) this.removeSearchingScreen()
    }

    updateMatchmakingStatus(matchmakingStatusUpdate: MatchmakingStatusUpdate) {
        this.matchmakingSearchingView.updateStatus(matchmakingStatusUpdate)
    }
}
